import React from 'react';

const GhostDiv = ({children}) => children


export default GhostDiv


// WEBPACK FOOTER //
// ./src/js/components/Assests/GhostDiv.jsx